module.exports = require("core-js-pure/features/object/keys");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs3/core-js/object/keys.js
// module id = 6443
// module chunks = 25